<template>
    <v-container fluid class="navbar-gradient navbar py-0" :class="{'isCheckout': isCheckout}">
        <MainHeader :isCheckout="isCheckout" />
    </v-container>
</template>

<script>
    import MainHeader from "../Header/MainHeader";

    export default {
        name: 'NavBar',
        props: ['isCheckout'],
        components: {
            MainHeader
        }
    }
</script>

<style lang="scss">
    .navbar-gradient {
        background: linear-gradient(to left, #4b982b 50%, #ffffff 50%);
        @media #{$phone-strict} {
            background: linear-gradient(to left, #10529e 30%, #ffffff 30%);
        }
        @media #{$pixel-less-phone} {
            background: linear-gradient(to left, #10529e 30%, #ffffff 30%);
        }
    }
</style>
